import styled from 'styled-components'

const Spinner = styled.div`
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`

export default {
  Spinner,
}
